import React, { useState } from "react";
import "../assets/styles/components/Contact.css";
import logo2 from "../assets/images/logo-acg-vo.jpg";


const ContactSaisie = ({ onSubmit, field = {} }) => {
  const [formData, setFormData] = useState({
    user_name: field.user_name || "",
    user_email: field.user_email || "",
    message: field.message || "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    //onSubmit(formData); // Envoie les données au parent
   
      onSubmit(formData); // Invoke the onSubmit function with the updated form data
    
  };

  return (
    <section className="contact-section py-5">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          {/* Logo and Title Section */}
          <div className="col-md-6 text-center mb-4">Modifier le formulaire
          <div className="hero-container">
              <h2 className="mb-4">
                ACG-VO votre partenaire pour des solutions flexibles et
                modernes
              </h2>
              <img
                src={logo2}
                alt="ACG-VO Logo"
                className="hero-logo img-fluid"
              />
            </div>
          </div>

          {/* Contact Form Section */}
          <div className="col-md-6" id="contact">
            <h2 className="text-center mb-3">Des questions ?</h2>
            <p className="text-center mb-4">
              Prenez contact avec nous aujourd'hui
            </p>

            <div className="form-container mx-auto" style={{ maxWidth: "500px" }}>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="user_name" className="form-label">
                    Nom prénom*
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="user_name"
                    name="user_name"
                    value={formData.user_name}
                    onChange={handleChange}
                    placeholder="Vos nom et prénom"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="user_email" className="form-label">
                    E-mail*
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="user_email"
                    name="user_email"
                    value={formData.user_email}
                    onChange={handleChange}
                    placeholder="Votre adresse e-mail"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="message" className="form-label">
                    Votre question*
                  </label>
                  <textarea
                    className="form-control"
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Bonjour, j'aimerais avoir des renseignements sur ..."
                    rows="4"
                    required
                  >Salut</textarea>
                </div>
                <button type="submit" className="btn btn-submit w-100">
                  Soumettre
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSaisie;
